import {
  CHANNELS_DELETE,
  CHANNELS_EDIT,
  CHANNELS_LIST,
} from "../constants/api-path";
import httpClient from "./http.interceptor";

/**
 * @param {page: number, limit: number, sortColumn: string|number, sortDirection: string } formData
 * @returns Promise<any>
 */
export const getAppChannels = (formData: any): Promise<any> => {
  return httpClient.get(CHANNELS_LIST, {
    params: {
      page: formData.page,
      pageSize: formData.limit,
      sort: formData.sort,
      search: formData.search,
      status: formData.status,
      department: formData.department,
      store: formData.store,
    },
  });
};

/**
 * @param {id: string } params
 * @returns Promise<any>
 */
export const deleteAppChannel = (id: string | number): Promise<any> => {
  return httpClient.delete(CHANNELS_DELETE + id);
};

export const toggleChannelStatus = (id: any, status: boolean): Promise<any> => {
  return httpClient.patch(`${CHANNELS_EDIT}${id}`, { status });
};
